import React, { useEffect, useState, useCallback } from 'react';
import styles from "./SpeciesForm.module.scss";
import {Button, ErrorMsg, Loading} from "@onegovbugs/onegov-react-components";

import {
  isCompleted,
  isNumeric,
  validate,
  scrollToError
} from "../../../../utils/Validation";
import { InputSearch } from 'components/common/inputSearch/InputSearch';
import speciesDetails from 'redux/reducers/importExport/speciesDetails';

export const SpeciesForm = ({
  props, 
  toggleAddSpeciesForm, 
  saveSpeciesDataHandler, 
  editSpecies, 
  inputSearchHandler, 
  speciesSearchDetails,
  validateDuplicateSpecies}) => { 

    const [showErrors, setShowErrors] = useState(false); 

    const [atlasId, setAtlasId] = useState(editSpecies ? editSpecies.atlasId : '');
    const [speciesCode, setSpeciesCode] = useState(editSpecies ? editSpecies.speciesCode : '');
    const [speciesCommonName, setSpeciesCommonName] = useState(editSpecies ? editSpecies.speciesCommonName :'');
    const [speciesGenus, setSpeciesGenus] = useState(editSpecies ? editSpecies.speciesGenus :'');
    const [species, setSpecies] = useState(editSpecies ? editSpecies.species :'');
    const [subSpecies, setSubSpecies] = useState(editSpecies ? editSpecies.subSpecies :'');
    const [speciesNoOfFauna, setSpeciesNoOfFauna] = useState(editSpecies ? editSpecies.speciesNoOfFauna : '');
    const [speciesClass, setSpeciesClass] = useState(editSpecies ? editSpecies.speciesClass : '');

    const [isSpeciesCodeValid, setIsSpeciesCodeValid] = useState(false); 
    const [showInputSearchError, setShowInputSearchError] = useState(false);
    const [inputSearchErrorMessage, setInputSearchErrorMessage] = useState(false);
    const [searchTextError, setSearchTextError] = useState(speciesSearchDetails ? speciesSearchDetails.searchTextError : null);

    const validateSpeciesCode = () => {
      if(speciesCode && speciesCode.length >= 2)
      {
        setIsSpeciesCodeValid(true);
        setShowInputSearchError(false);
        setInputSearchErrorMessage('')

      } else {
        setIsSpeciesCodeValid(false);
        setShowInputSearchError(true);
        setInputSearchErrorMessage('Species Code is invalid.')
        // setInputSearchError({ isValid:isSpeciesCodeValid, message: inputSearchErrorMessage, showError: showInputSearchError });        
        return false;
      }

      // if(speciesSearchDetails.species && speciesSearchDetails.species.isValid)
      // {
      //   setIsSpeciesCodeValid(true);
      //   setShowInputSearchError(false);
      //   setInputSearchErrorMessage('')
      //   return;
      // } else {
      //   setIsSpeciesCodeValid(false);
      //   setShowInputSearchError(true);
      //   setInputSearchErrorMessage('Species Code is not valid.')
      //   return false;
      // }      
      
      return true;
    }

    const [errors, setErrors] = useState({
      // speciesCode: false,
      speciesNoOfFauna:false
    });

    const validators = [
      // {
      //   fieldName: "speciesCode",
      //   fieldValue: speciesCode,
      //   isValid: isCompleted
      // },
      {
        fieldName: "speciesNoOfFauna",
        fieldValue: speciesNoOfFauna,
        isValid:  val => val && val.length >= 1
      },      
    ];

    const searchHandler = useCallback(
      (enteredFilter) => {
        setIsSpeciesCodeValid(true);
        setShowInputSearchError(false);
        setInputSearchErrorMessage('')
        inputSearchHandler(enteredFilter);
      },[inputSearchHandler, speciesSearchDetails]
    );

    useEffect(() => {
      // if(!editSpecies){
        if(speciesSearchDetails.species && speciesSearchDetails.species.isValid)
        {
          setAtlasId(speciesSearchDetails.species.atlasId);
          setSpeciesCode(speciesSearchDetails.species.speciesCode);
          setSpeciesCommonName(speciesSearchDetails.species.commonName);
          setSpeciesGenus(speciesSearchDetails.species.genus);
          setSpecies(speciesSearchDetails.species.species);
          setSubSpecies(speciesSearchDetails.species.subspecies);
          setSpeciesClass(speciesSearchDetails.species.class);
        } else if ((speciesSearchDetails.searchText && speciesSearchDetails.searchText.length > 0 && !speciesSearchDetails.searchTextError)) {
          setAtlasId('');
          setSpeciesCode('');
          setSpeciesCommonName('');
          setSpeciesGenus('');
          setSpecies('');
          setSubSpecies('');
          setSpeciesNoOfFauna('');
          setSpeciesClass('');
        }    
        else if (speciesSearchDetails.species && !speciesSearchDetails.species.isValid && !speciesSearchDetails.searchTextError) {
            setAtlasId('');
            setSpeciesCode('');
            setSpeciesCommonName('');
            setSpeciesGenus('');
            setSpecies('');
            setSubSpecies('');
            setSpeciesNoOfFauna('');
            setSpeciesClass('');
        }

        setSearchTextError(speciesSearchDetails.searchTextError);
        // setShowInputSearchError(false);
        // setShowErrors(false);

    }, [speciesSearchDetails]);

    const renderSpeciesForm = () => {
      return (
        <div>
          <div className={"row"}>
            <div className={"col-12"}>
              <h2>Add Species</h2>
            </div>
          </div>


          <div className={"row"}>
  
            <div className={"col-12 col-sm-6"}>
              <label htmlFor="inputSpeciesCode" className={styles.smallParagraph}>
                Species Code
              </label>
              <InputSearch 
                inputSearchHandler= {searchHandler} 
                speciesCode= {speciesCode}
                searchTextError = {searchTextError}
              />          
              {isSpeciesCodeValid === false && showInputSearchError ? (
                  <ErrorMsg 
                    className={"ErrorMsg_error"}
                    type={"error"}
                    description={inputSearchErrorMessage}
                  />
                ) : null}              
            </div>

            <div className={"col-12 col-sm-6"}>
                <label
                  htmlFor="inputNumberOfFauna"
                  className={styles.smallParagraph}
                >
                  Number of Fauna
                </label>
                <input
                  id="inputNumberOfFauna"
                  className={`${styles.inputBox}`}
                  // holder={"Number of Fauna"}
                  maxLength="20"
                  value={speciesNoOfFauna}
                  onChange={event => {
                    setSpeciesNoOfFauna(event.target.value);
                  }}
                />
                {showErrors ? (
                  errors.speciesNoOfFauna ? (
                    <ErrorMsg 
                      className={"ErrorMsg_error"}
                      type={"error"}
                      description={"Number of Fauna is required."}
                    />
                  ) : (isNumeric(speciesNoOfFauna) != true ?
                  (<ErrorMsg
                    className={"ErrorMsg_error"}
                    type={"error"}
                    description={"Invalid value for Number of Fauna."}
                  />) : null)
                ) : null}                           
              </div>            


            {/* <div className={"col-12 col-sm-6"}>
              <label htmlFor="inputSpeciesCode" className={styles.smallParagraph}>
                Species Code
              </label>
              <input
                id="inputSpeciesCode"
                className={`${styles.inputBox}`}
                placeholder={"Species Code"}
                value={speciesCode}
                onChange={event => {
                  setSpeciesCode(event.target.value);
                }}
              />
              {errors.speciesCode && showErrors ? (
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Species Code is required."}
                />
              ) : null}
            </div> */}
  
          </div>

          {
              speciesSearchDetails.loading &&
              <div className='row'>
                <div className={"col-12"}>
                  <Loading
                      className={styles.loading}
                      label={"Loading..."}
                      type={"ajax"}
                  />
                </div>
              </div>
          }


          {
            !speciesSearchDetails.loading &&

          <React.Fragment>
            <fieldset disabled>
              <div className='row'>

                  <div className={"col-12 col-sm-6"}>
                    <label
                      htmlFor="inputCommonName"
                      className={styles.smallParagraph}
                    >
                      Common Name
                    </label>
                    <input
                      readOnly 
                      // className="form-control-plaintext"
                      id="inputCommonName"
                      className={`${styles.inputBox}`}
                      // placeholder={"Common Name"}
                      maxLength="20"
                      value={speciesCommonName}
                      // onChange={event => {
                      //   setSpeciesGenus(event.target.value);
                      // }}
                    />
        
                    {/* {(employerMobileNumber == null || employerMobileNumber == "") && errors.employerMobileNumber && showErrors ? (
                      <ErrorMsg className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Mobile number is required."}
                      />
                    ) : null}
                    {employerMobileNumber !== null && employerMobileNumber !== "" && errors.employerMobileNumber && showErrors ? (
                      <ErrorMsg className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Mobile number is invalid."}
                      />
                    ) : null} */}
                  </div>

                  <div className={"col-12 col-sm-6"}>
                    <label
                      htmlFor="inputGenus"
                      className={styles.smallParagraph}
                    >
                      Genus
                    </label>
                    <input
                    readOnly
                      id="inputGenus"
                      className={`${styles.inputBox}`}
                      // placeholder={"Common Name"}
                      maxLength="20"
                      value={speciesGenus}
                      // onChange={event => {
                      //   setSpeciesCommonName(event.target.value);
                      // }}                  
                    />
                  </div>

              </div>

              <div className='row'>

                  <div className={"col-12 col-sm-6"}>
                    <label
                      htmlFor="inputSpecies"
                      className={styles.smallParagraph}
                    >
                      Species
                    </label>
                    <input
                      readOnly
                      id="inputSpecies"
                      className={`${styles.inputBox}`}
                      // placeholder={"Common Name"}
                      maxLength="20"
                      value={species}
                    />
                  </div>

                  <div className={"col-12 col-sm-6"}>
                    <label
                      htmlFor="inputSubSpecies"
                      className={styles.smallParagraph}
                    >
                      Subspecies
                    </label>
                    <input
                      readOnly
                      id="inputSubSpecies"
                      className={`${styles.inputBox}`}
                      // placeholder={"Common Name"}
                      maxLength="20"
                      value={subSpecies}
                    />
                  </div>
              </div>          

            </fieldset>

            <div className={"row " + styles.topMargin128}>
                <div className={"col-12"}>
                  <Button
                    onClick={() => {
                      
                      const isDulplicateSpecies = validateDuplicateSpecies(speciesCode);
                      
                      if(isDulplicateSpecies)
                      {
                        
                        return;
                      }  

                      const isSpeciesCodeValid = validateSpeciesCode();
                      
                      if (validate(validators, setErrors) && isSpeciesCodeValid) {
                        saveSpeciesData();
                        // setViewMode("list");
                        // clearForm();
                        toggleAddSpeciesForm(false);                                               
                      } else {
                        setShowErrors(true);
                        scrollToError();
                      }
                    }}
                  >
                    Save
                  </Button>
                  <Button secondary onClick={() => {
                    //setSaveMode("");
                    //setViewMode("list");
                    toggleAddSpeciesForm(false);
                    // clearForm();
                    //setShowErrors(false);
                  }}>
                    Cancel
                  </Button>
                </div>
              </div>             

          </React.Fragment>

          }
          
        </div>
      );
    };        

   
    const saveSpeciesData = () => {
        const newSpecies = 
            {
              atlasId: atlasId,
              speciesCode: speciesCode,
              speciesCommonName: speciesCommonName,
              speciesGenus: speciesGenus,
              species: species,
              subSpecies: subSpecies,
              speciesNoOfFauna: speciesNoOfFauna,
              speciesClass: speciesClass
            };
        
        saveSpeciesDataHandler(newSpecies);

        window.setTimeout(() => {
          setErrors({
            speciesCode: false,
            speciesNoOfFauna:false
          })
        }, 1000);
        
    };

    return (
        <div className={styles.mainCont}>
            {renderSpeciesForm()}   
        </div>
      
    )
}